import React from 'react';
import { useAuth } from '../context/shared/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute: React.FC = () => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    // Show a loading indicator while auth state is initializing
    return <div>Loading...</div>; 
  }

  if (!isAuthenticated || !user) {
    // If user is not logged in, redirect to login
    return <Navigate to="/login" replace />;
  }

  // Check if user has admin role
  if (user.role !== 'admin') {
    // If the user is not an admin, redirect to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  // If user is an admin, render the child routes
  return <Outlet />;
};

export default AdminRoute; 